(function () {

    'use strict';
    angular.module('app')
        .controller('detachAccountsController', ['$scope', '$uibModalInstance', '$location', 'dashboardService', 'clientsToDetach', 'collection', detachAccountsController]
            );

    function detachAccountsController($scope, $uibModalInstance, $location, dashboardService, clientsToDetach, collection) {

        $scope.model = {};

        $scope.model.Collection = collection;
        $scope.model.AccountsForRemoval = clientsToDetach;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.RemoveMultipleAccounts = function () {

            dashboardService.removeClientUser($scope.model.AccountsForRemoval[0].id)
                .then(function () {

                    var tmpArray = [];
                    var emailAddress = $scope.model.AccountsForRemoval[0].emailAddress;

                    $scope.model.Collection.forEach(function (account) {

                        if (account.emailAddress !== emailAddress)
                            tmpArray.push(account);

                    });
                    $uibModalInstance.close({ success: true, accounts: tmpArray });
                },
                    function (response) {
                        // error
                        alert(response.error);
                    });


        };

    }
})();